import * as React from "react";
import { useState, useEffect} from "react";
import Modal from "../core/Modal";
import { toast } from "../../utils";
import * as moment from "moment";
import Gravatar from "../core/Gravatar";
import Tooltip from "react-tooltip";
import Select from 'react-select-new';


interface IProps {
  userContext?:any;
  hasMarketing?:any;
  v2Token?:any;
  lsSettings?:any;
}

function LeadSafari(props:IProps){

  function handle_select(e){
    set_activity_id(e.value);
    return e.value;
  }

  // FUNCTIONS
  async function get_activity_types_html(v2_token, rec_id){
    let json = await get_activity_types(v2_token, rec_id);
    let options = [];

    Object.entries(json).map(([key, value] : any) => {
      options.push({value : value.id, label: value.name});
    })
    set_activity_id(json[0].id);
    set_activity_types(options);
  }

  async function get_activity_types(v2_token, rec_id) {
    let resp = await fetch(`https://api.chartec.net/v2/connectwise/sales/activities/types/${rec_id}`, {
      method: 'GET', 
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': v2_token
      }
    })
    let json = await resp.json();
    return json;
  }

  async function get_cw_assignment_id(v2_token, rec_id, email){
    let string = {"email": email.user.data.attributes.email};
    let resp = await fetch(`https://api.chartec.net/v2/connectwise/system/members/${rec_id}`, {
      method: 'POST', 
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': v2_token
      },
      body: JSON.stringify(string)
    })
    let json = await resp.json();
    set_assign_to_full(json[0]);
    set_assign_to(json[0].id);
  }

  //load contacts for non campaign lists, filterable 
  async function load_filtered_contacts(v2_token, rec_id, page=1, update:any=null){
    set_loading(true);
    var json_string;
    if(update != null){
      update.page = page;
      json_string = update;
    } else {
      let order = filter_options.order;
      let order_direction = filter_options.order_direction;
      let sort_id = filter_options.sort_id;
      let tag_id = filter_options.tag_id;
      let list_id = filter_options.list_id;
      let search = search_term;
      json_string = {"order":order, "order_direction":order_direction, "sort_id":sort_id, "tag_id":tag_id, "list_id":list_id, "page":page, "search":search};
    }
    let resp = await fetch(`https://api.chartec.net/v2/ac/contacts/${rec_id}/filtered`, {
      method: 'POST', 
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': v2_token
      },
      body: JSON.stringify(json_string)
    });

    let json = await resp.json();
    json_string.resp = json;
    set_filter_options(json_string);
  }

  //generate table rows for non campaign lists
  async function generate_table(v2_token, rec_id, json){
    let c_html = [];
    let emails = [];
    let contacts = json.contacts;
    Object.keys(contacts).forEach(function(k){
      if(k.match(/^[0-9]+$/) != null){
        emails.push(contacts[k].email);
      }
    });
    // eslint-disable-next-line promise/catch-or-return
    get_sales_activities_and_contact_ids(v2_token, rec_id, emails).then(result => {
      build_rows(v2_token, rec_id, contacts, result, 0, json);
      generate_pagination(json.pages,0,v2_token,rec_id);
    });
  }

  async function get_sales_activities_and_contact_ids(v2_token, rec_id, emails, list_id=null){
    let string = ((list_id == null ||  list_id == 0) ? {"emails":[], "name":"", "dates":dates} :  {"emails":[], "name":"/CORE("+list_id+")", "dates":dates});
    emails.forEach(email => {
      string["emails"].push({"email":email});
    });
    let resp = await fetch(`https://api.chartec.net/v2/connectwise/sales/activities/${rec_id}`, {
      method: 'POST', 
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': v2_token
      },
      body: JSON.stringify(string)
    })
    let json = await resp.json();
    return json;
  }

  //pagination
  async function generate_pagination(page_info,id=0,v2_token,rec_id){
    var i=1,html=[];
    let lowest = [];
    lowest.push(<li className={page_info.current_page == 1 ? "active" : ""}><span style={{zIndex: 0}} className="btn" onClick={() => get_new_page(1,id,v2_token,rec_id)}>1</span></li>);
    let max = [];
    if(page_info.current_page != page_info.pages){
      max.push(<li className={page_info.current_page == page_info.pages ? "active" : ""}><span style={{zIndex: 0}} className="btn" onClick={() => get_new_page(page_info.pages,id,v2_token,rec_id)}>{page_info.pages}</span></li>);
    }
    
    if(page_info.pages > 8){
      //left side start
      if((page_info.current_page - 2) <= 1){
        let i = page_info.current_page - 1;
        if(i >=2){
          let index = i;
          html.push(<li><span data-left-page={index} className="btn" onClick={() => get_new_page(index,id,v2_token,rec_id)}>{index}</span></li>);
        }
        i = page_info.current_page - 2;
        if(i >= 2){
          let index = i;
          html.push(<li><span data-left-page={index} className="btn" onClick={() => get_new_page(index,id,v2_token,rec_id)}>{index}</span></li>);
        }
      } else {
        html.push(<li><span className="btn">...</span></li>);
        let i = page_info.current_page - 2;
        if(i != 1){
          let index = i;
          html.push(<li><span data-left-page={index} className="btn" onClick={() => get_new_page(index,id,v2_token,rec_id)}>{index}</span></li>);
        }
        i = page_info.current_page - 1;
        if(i != 1){
          let index = i;
          html.push(<li><span data-left-page={index} className="btn" onClick={() => get_new_page(index,id,v2_token,rec_id)}>{index}</span></li>);
        }
      }
  
      //current
      if(page_info.current_page != 1 && page_info.current_page != page_info.pages){
        html.push(<li className="active"><span data-left-page={page_info.current_page} className="btn">{page_info.current_page}</span></li>);
      }
      
      //right start
      if((page_info.current_page + 2) >= page_info.pages){
        let i = page_info.current_page + 1;
        if(i <= page_info.pages && i != page_info.pages){
          let index = i;
          html.push(<li><span data-right-page={index} className="btn" onClick={() => get_new_page(index,id,v2_token,rec_id)}>{index}</span></li>);
        }
        i = page_info.current_page + 2;
        if(i <= page_info.pages && i != page_info.pages){
          let index = i;
          html.push(<li><span data-right-page={index} className="btn" onClick={() => get_new_page(index,id,v2_token,rec_id)}>{index}</span></li>);
        }
      } else {
        let i = page_info.current_page + 1;
        if(i != 1 && i != page_info.pages){
          let index = i;
          html.push(<li><span data-right-page={index} className="btn" onClick={() => get_new_page(index,id,v2_token,rec_id)}>{index}</span></li>);
        }
        i = page_info.current_page + 2;
        if(i != 1 && i != page_info.pages){
          let index = i;
          html.push(<li><span data-right-page={index} className="btn" onClick={() => get_new_page(index,id,v2_token,rec_id)}>{index}</span></li>);
        }
        if(i != 1 && (page_info.current_page + 3) != page_info.pages){
          html.push(<li><span className="btn">...</span></li>);
        }
      }
    } else {
      for (i = 1; i <= page_info.pages; i++) {
        let index = i;
        if(i != 1 && i != page_info.pages){
          html.push(<li className={page_info.current_page == i ? "active" : ""}><span className="btn" onClick={() => get_new_page(index,id,v2_token,rec_id)}>{i}</span></li>);
        }
      }
    }
    let left = [<li key="1">
     {page_info.current_page == 1 ? '' : <span className="btn" onClick={() => get_new_page(page_info.current_page - 1,id,v2_token,rec_id)}><span aria-hidden="true">&laquo;</span></span>}
    </li>];
    let right = [<li key="2">
    {page_info.current_page == page_info.pages ? '' : <span className="btn" onClick={() => get_new_page(page_info.current_page + 1,id,v2_token,rec_id)}><span aria-hidden="true">&raquo;</span></span>}
   </li>];
   let p_html = [];
    p_html.push(<nav>
      <button style={{position : 'absolute', left : '16px'}} onClick={() => (get_new_page(page_info.current_page,id,v2_token,rec_id))} className="pull-left btn btn-secondary"><i className="fa fa-refresh"></i></button>
      <ul className="pagination">
        {left}
        {lowest}
        {html}
        {max}
        {right}
      </ul>
    </nav>);
    set_pagination(p_html);
  }

  function get_new_page(page,id,v2_token,rec_id){
    set_pagination([]);
    if(id == 0){
      load_filtered_contacts(v2_token, rec_id, page);
    } else {
      switch_list(id,v2_token,rec_id,page);
    }
  }

  function filter(v2_token, rec_id, change, page=1){
    let update = {...filter_options};
    Object.keys(change).forEach(function(c){
      let key = c;
      let value = change[key];
      update[key] = value;
    });
    load_filtered_contacts(v2_token, rec_id, page, update);
  }

  async function switch_list(id,v2_token,rec_id,page=1){
    set_pagination([]);
    set_loading(true);
    let resp = await fetch(`https://api.chartec.net/v2/ac/campaign_report_open_list/${rec_id}/${id}/${page}`, {
      method: 'GET', 
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': v2_token
      }
    })
    let json = await resp.json();
    let emails = [];
    Object.keys(json).forEach(function(k){
      if(k.match(/^[0-9]+$/) != null){
        emails.push(json[k].email);
      }
    });
    // eslint-disable-next-line promise/catch-or-return
    get_sales_activities_and_contact_ids(v2_token, rec_id, emails, id).then(result => {
      build_rows(v2_token, rec_id, json, result, id);
      generate_pagination(json.page,id,v2_token,rec_id);
    });
  }

  async function list_ac_items(v2_token, rec_id){
    let resp = await fetch(`https://api.chartec.net/v2/ac/ac_items/${rec_id}`, {
      method: 'GET', 
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': v2_token
      }
    })
    let json = await resp.json();
    let campaign_list = [];
    let options_html = [{value:'none', label:'Select Campaign'}];
    json.campaigns.forEach((c,i) => {
      options_html.push({value : c.id, label: c.name+" - "+moment(c.sdate).format("MM-DD-YY")});
      campaign_list.push({"id":c.id, "name":c.name});
    });
    let lists_html = [{value:'', label:'ALL'}];
    json.lists.forEach((l,i) => {
      lists_html.push({value : l.id, label: l.name});
    });
    let tags_html = [{value:'', label:'ALL'}];
    json.tags.forEach((t,i) => {
      tags_html.push({value : t.id, label: t.tag});
    });
    set_campaign_select(options_html);
    set_tag_select(tags_html);
    set_list_select(lists_html);
    set_ac_items_loading(false);
    //get opens from most recent campaign on load
  }
  
  async function get_campaigns(v2_token, rec_id){
    let resp = await fetch(`https://api.chartec.net/v2/ac/campaigns/${rec_id}`, {
      method: 'GET', 
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': v2_token
      }
    })
    let json = await resp.json();
    return json;
  }

  async function create_activity(v2_token, rec_id, assign_to, add_activity, notes, summary, activity_id, contacts, set_contacts, index_id, ac_contact_id, create_status_id, time_entry_start, time_entry_end){
    set_request_loading(true);
    let name = (add_activity.list_id == 0 ? summary : summary+" /CORE("+add_activity.list_id+")");
    let string = [
      {"name":name},
      {"contact":{"id":add_activity.contact_id}},
      {"type":{"id":activity_id }},
      {"assignTo":{"id":assign_to }},
      {"notes":notes},
      {"company":{"id": add_activity.contact.company.id}},
      {"status":{"id" : create_status_id}}, 
      {"time_entry":{"start":time_entry_start, "end":time_entry_end}},
      {"ls_settings" : ls_settings},
      {"assign_full" : assign_to_full}
    ];
    let resp = await fetch(`https://api.chartec.net/v2/connectwise/sales/create_activity/${rec_id}`, {
      method: 'POST', 
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': v2_token
      },
      body: JSON.stringify(string)
    })
    let json = await resp.json();
      if(json.id){
        setTimeout(function () {
          update_row(json, v2_token, rec_id, add_activity.list_id, index_id, ac_contact_id);
      }, 500);
      return true;
    } else {
      return false;
    }
  }

  async function update_row(request, v2_token, rec_id, list_id, index_id, ac_contact_id){
    // for score on user use the same request as you did when you are loading the modal
    let email_arr = [request.email];
    let email = request.email;
    let c_html = [];
    let activites = {};
    let all_activities = {};
    let activity_counts = [];
    // eslint-disable-next-line promise/catch-or-return
    get_sales_activities_and_contact_ids(v2_token, rec_id, email_arr, list_id).then(result => {
          Object.keys(result[email]).forEach(function(r){
            if(r.match(/^[0-9]+$/) != null){
              let short = result[email][r];
              activites[short['type'].name] = activites[short['type'].name] || [];
              activites[short['type'].name].push(short);
            }
            if(r == 'all'){
              all_activities = result[email][r];
            }
          });
  
          if(Object.entries(all_activities).length != 0){
            Object.keys(all_activities).forEach(function(a){
              if(!(all_activities[a].assignTo.id in activity_counts)){
                activity_counts.push(all_activities[a].assignTo.id);
              }
            });
          }
  
          //seperate activity into counts 
          let counts = {};
          activity_counts.forEach(function (x) {
            var email_all = result['all_members'].filter(obj => {
              return obj.id === x;
            });
            counts[email_all[0]['defaultEmail']] = (counts[email_all[0]['defaultEmail']] || 0) + 1;
          });
          //begin html building
          let g_html = [];
          Object.keys(counts).forEach(function(c){
            g_html.push(<span className="avatars__item"><Gravatar className="avatar" email={c} size={"30"} /></span>);
          })
  
          let a_html = [];
          if(Object.keys(activites).length){
            Object.keys(activites).forEach(function(a){
              a_html.push(<div style={{float:"left", display: "flex", padding: "5px", marginLeft: "10px", borderLeft: "1px solid #ddd"}}><small style={{textAlign : "center"}}><strong>{a}'s</strong><br/><span className="badge badge-secondary">{activites[a].length} of 3</span></small></div>);
            })
          } else {
            a_html.push(<span className="badge badge-danger">No touches for this contact</span>);
          }
          let short_1 = result[email].contact[0];
          c_html.push(<tr data-id={index_id} data-email={request.email}>
            <td className="col-md-2">{short_1.firstName} {short_1.lastName} <button onClick={() => {set_add_activity({open:true, type:'', email:request.email, contact_id:short_1.id, list_id:list_id, index_id:index_id, ac_contact_id: '', contact:short_1}), get_ac_activites_and_scores(v2_token, rec_id, ac_contact_id, all_activities), set_history(true)}} className="btn-sm btn btn-secondary"><i className="fa fa-history"></i></button> </td>
            <td className="col-md-2"><a href="">{request.email}</a><br/><a href="">{request.phoneNumber}</a></td>
            <td className="col-md-2">{short_1.company.name}</td>
            <td className="col-md-2 touches">{a_html}</td>
            <td className="col-md-2">
              <div className="avatars">
                {g_html}
              </div>
            </td>
            <td className="col-md-2"><div className="btn-group">
              <button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown">Options  <span className="caret"></span></button>
              <ul className="dropdown-menu" role="menu">
                <li key="1"><span onClick={() => {set_add_activity({open:true, type:'', email:request.email, contact_id:short_1.id, list_id:list_id, index_id:index_id, ac_contact_id: '', contact:short_1}), get_ac_activites_and_scores(v2_token, rec_id, ac_contact_id, all_activities), set_history(false)}}>Create Activity</span></li>
                {/* <li key="2"><span onClick={() => set_add_activity({open:true, type:'', email:request.email, contact_id:short_1.id, list_id:list_id, index_id:index_id, ac_contact_id: ''})}>Send TimeZest</span></li>
                <li key="3"><span onClick={() => set_add_activity({open:true, type:'', email:request.email, contact_id:short_1.id, list_id:list_id, index_id:index_id, ac_contact_id: ''})}>Make Call</span></li>
                <li key="4"><span onClick={() => set_add_activity({open:true, type:'', email:request.email, contact_id:short_1.id, list_id:list_id, index_id:index_id, ac_contact_id: ''})}>Send Email</span></li> */}
              </ul>
              </div>
            </td>
          </tr>);
  
          let new_contacts = [...contacts];
          new_contacts[index_id] = c_html;
          set_contacts(new_contacts);
    });
  }

  async function get_ac_activites_and_scores(v2_token, rec_id, contact, all_activities){
    let loading_html = [];
    let small_loading = [];
    small_loading.push(<div><i className="fa fa-cog fa-spin fa-1x"></i><br/></div>);
    loading_html.push(<div className="row" style={{paddingTop : "15px"}}>
      <div className="col-xs-3 col-md-offset-4">
        <div className="panel panel-default">
          <div className="panel-body">
            <div style={{textAlign: "center"}}>
            <i className="fa fa-cog fa-spin fa-2x"></i><br/>
            Loading
            </div>
          </div>
        </div>
      </div>
    </div>);
    set_ac_lists(small_loading);
    set_ac_tags(small_loading);
    set_ac_activities(loading_html);
    set_cw_activities(loading_html);
    let campaigns = await get_campaigns(v2_token, rec_id);
    let cw_html = [];
    Object.keys(all_activities).forEach(function(cw){
      let cw_short = all_activities[cw];
      let campaign_id = cw_short.name.split('(').pop().split(')')[0];
      let ci = campaigns.campaigns.findIndex(c => c.id == campaign_id);
      let campaign_name = campaigns.campaigns[ci]?.name || 'none';
      let title = cw_short.name.split('/')[0];
      cw_html.push(<div className="panel panel-default">
      <div className="panel-heading">{title}</div>
      <div className="panel-body">
        <small><b>Assigned To : </b></small>{cw_short.assignTo.name}<br/>
        <small><b>Type : </b></small>{cw_short.type.name}<br/>
        <small><b>Campaign : </b></small>{campaign_name}<br/>
        <small><b>Notes : </b></small>{cw_short.notes}<br/>
        <small><b>Status : </b></small>{cw_short.status.name}<br/>
        <small>{moment(cw_short.dateStart).fromNow()}</small>
      </div>
    </div>);
    });
    set_cw_activities(cw_html.reverse());
  
  
    let resp = await fetch(`https://api.chartec.net/v2/ac/activities/${rec_id}/${contact}`, {
      method: 'GET', 
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': v2_token
      }
    })
    let json = await resp.json();
    let html = [];
    Object.keys(json.activities).forEach(function(r){
      let r_short = json.activities[r];
      html.push(<div className="panel panel-default">
        <div className="panel-heading">{r_short.label}</div>
        <div className="panel-body">
          {r_short.summary} ({r_short.name})<br/>
          <small>{moment(r_short.tstamp).fromNow()}</small>
        </div>
      </div>);
    })
    let t_html = [];
    Object.keys(json.tags).forEach(function(t){
      let t_short = json.tags[t];
      t_html.push(<span style={{marginRight : "5px", padding : "3px"}} className="badge badge-secondary">{t_short.name}</span>);
    });
    let l_html = [];
    Object.keys(json.lists).forEach(function(l){
      let l_short = json.lists[l];
      l_html.push(<span style={{marginRight : "5px", padding : "3px"}} className="badge badge-secondary">{l_short.name}</span>);
    });
    let s_html = [];
    s_html.push(<span style={{marginRight : "5px", padding : "3px"}} className="badge badge-info">Contact Score : {json.score_total}</span>);
  
    set_ac_scores(s_html);
    set_ac_lists(l_html);
    set_ac_tags(t_html);
    set_ac_activities(html);
  }

  async function build_rows(v2_token, rec_id, json, result, id, extras:any=''){
    let c_html = [];
    let index_id = 0;
    Object.keys(json).forEach(function(k){
      if(k.match(/^[0-9]+$/) != null && Object.keys(result[json[k].email].contact).length){
        var current_id = index_id;
        let contact_email = json[k].email;
        let ac_contact_id = json[k].id;
        let contact_id = result[json[k].email].contact.id;
        let company_name = result[json[k].email].contact.company.name;
        let contact_phone = result[json[k].email].contact.defaultPhoneNbr;
        let activites = {};
        let all_activities = {};
        let score = 0;
        let activity_counts = [];
        //check if theres scores
        if(extras){
          let score_arr = extras.scoreValues.filter(obj => {
            return obj.contact == ac_contact_id
          });
          score_arr.forEach(s => {
            score = (+score + +s.scoreValue);
          });
        }
        Object.keys(result[json[k].email]).forEach(function(r){
          if(r.match(/^[0-9]+$/) != null){
            let short = result[json[k].email][r];
            activites[short['type'].name] = activites[short['type'].name] || [];
            activites[short['type'].name].push(short);
          }
          if(r == 'all'){
            all_activities = result[json[k].email][r];
          }
        });
  
        if(Object.entries(all_activities).length != 0){
          Object.keys(all_activities).forEach(function(a){
            if(!(all_activities[a].assignTo.id in activity_counts)){
              activity_counts.push(all_activities[a].assignTo.id);
            }
          });
        }
  
        //seperate activity into counts 
        let counts = {};
        activity_counts.forEach(function (x) {
          var email = result['all_members'].filter(obj => {
            return obj.id === x;
          });
          if(!counts.hasOwnProperty(email[0]['defaultEmail'])){
            counts[email[0]['defaultEmail']] = [];
          }
          counts[email[0]['defaultEmail']]['count'] = (counts[email[0]['defaultEmail']]['count'] || 0) + 1;
          counts[email[0]['defaultEmail']]['name'] = email[0]['fullName'];
        });
        //begin html building
        let g_html = [];
        Object.keys(counts).forEach(function(c){
          g_html.push(<span className="avatars__item" data-tip data-for={c}><Gravatar className="avatar" email={c} size={"30"} /><Tooltip id={c}>{counts[c].name}</Tooltip></span>);
        })
        let a_html = [];
        if(Object.keys(activites).length){
          Object.keys(activites).forEach(function(a){
            a_html.push(<div style={{float:"left", display: "flex", padding: "5px", marginLeft: "10px", borderLeft: "1px solid #ddd"}}><small style={{textAlign : "center"}}><strong>{a}'s</strong><br/><span className="badge badge-secondary">{activites[a].length} of 3</span></small></div>);
          })
        } else {
          a_html.push(<span className="badge badge-danger">No touches for this contact</span>);
        }
        
        c_html.push(<tr data-test={ac_contact_id} data-id={index_id} data-email={json[k].email}>
          <td className="col-md-2">{json[k].firstName} {json[k].lastName} <button onClick={() => {set_add_activity({open:true, type:'', email:contact_email, contact_id:contact_id, list_id:id, index_id:current_id, ac_contact_id, contact:result[json[k].email].contact}), get_ac_activites_and_scores(v2_token, rec_id, ac_contact_id, all_activities), set_history(true)}} className="btn-sm btn btn-secondary"><i className="fa fa-history"></i></button> {(extras ? <div><br/><span style={{marginRight : "5px", padding : "3px"}} className="badge badge-info">Contact Score : {score}</span></div> : '')}</td>
          <td className="col-md-2"><a href="">{json[k].email}</a><br/><a href="">{contact_phone}</a></td>
          <td className="col-md-2">{company_name}</td>
          <td className="col-md-2 touches">
            {a_html}
          </td>
          <td className="col-md-2">
            <div className="avatars">
              {g_html}
            </div>
          </td>
          <td className="col-md-2">
            <div className="btn-group">
              <button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown">Options  <span className="caret"></span></button>
              <ul className="dropdown-menu" role="menu">
                <li key="1"><span onClick={() => {set_add_activity({open:true, type:'', email:contact_email, contact_id:contact_id, list_id:id, index_id:current_id, ac_contact_id, contact:result[json[k].email].contact}), get_ac_activites_and_scores(v2_token, rec_id, ac_contact_id, all_activities), set_history(false)}}>Create Activity</span></li>
                {/* <li key="2"><span onClick={() => set_add_activity({open:true, type:'', email:contact_email, contact_id:contact_id, list_id:id, index_id:current_id, ac_contact_id})}>Send TimeZest</span></li>
                <li key="3"><span onClick={() => set_add_activity({open:true, type:'', email:contact_email, contact_id:contact_id, list_id:id, index_id:current_id, ac_contact_id})}>Make Call</span></li>
                <li key="4"><span onClick={() => set_add_activity({open:true, type:'', email:contact_email, contact_id:contact_id, list_id:id, index_id:current_id, ac_contact_id})}>Send Email</span></li> */}
              </ul>
            </div>
          </td>
        </tr>);
      }
      index_id++;
    });
    set_list_id(id);
    set_contacts(c_html);
    set_loading(false);
  }

  async function getJobs(){
    let resp = await fetch(`https://api.chartec.net/v2/core/jobs/${rec_id}?id=asd6yb5i465l339j0s0j033ksdiwDaaa`, {
      method: 'GET', 
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': v2_token
      }
    })
    let json = await resp.json();
    let cw_api_jobs = json.filter(job => job.type == 'cw_init_sync');
    if(cw_api_jobs.length){
      if(cw_api_jobs[0].processed == 1){
        //continue
        set_progress([]);
      } else {
        if(cw_api_jobs[0].hasOwnProperty("json")){
          let progress = JSON.parse(cw_api_jobs[0].json).percent_complete;
          let html = [];
          html.push(<span><h6>Importing your CW data for Lead Safari</h6><div className="progress" style={{height : "22px"}}>
            <div className="progress-bar progress-bar-striped active" role="progressbar"
            aria-valuenow={progress} aria-valuemin={0} aria-valuemax={100} style={{width: progress+'%', height : "22px", marginBottom : "0px"}}>
              {progress}%
            </div>
          </div></span>);
          set_progress(html);
        }
      }
    } else {
      let html = [];
      html.push(<span>CW Import not started. Please contact support.</span>);
      set_progress(html);
    }
  }

  async function get_activity_statuses(v2_token, rec_id) {
    let resp = await fetch(`https://api.chartec.net/v2/connectwise/sales/activities/statuses/${rec_id}`, {
      method: 'GET', 
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': v2_token
      }
    })
    let json = await resp.json();
    let options = [];

    Object.entries(json).map(([key, value] : any) => {
      options.push({value : value.id, label: value.name});
    })

    set_activity_statuses(options);
  }

  async function search() {
    load_filtered_contacts(v2_token, rec_id);
  }


  // STATE
  let v2_token = props.v2Token;
  let ls_settings = props.lsSettings;
  let rec_id = props.userContext.organization.data.attributes.connectWise.cwRecid;
  var date = new Date();
  const [campaign_select, set_campaign_select] = useState([]);
  const [list_select, set_list_select] = useState([]);
  const [tag_select, set_tag_select] = useState([]);
  const [contacts, set_contacts] = useState([]);
  const [loading, set_loading] = useState(true);
  const [add_activity, set_add_activity] = useState({open:false, type:'', email:'', contact_id:'', list_id:'', index_id:0, ac_contact_id: '', contact:{}});
  const [pagination, set_pagination] = useState([]);
  const [assign_to, set_assign_to] = useState();
  const [assign_to_full, set_assign_to_full] = useState([]);
  const [list_id, set_list_id] = useState(0);
  const [notes, set_notes] = useState("");
  const [summary, set_summary] = useState("");
  const [activity_types, set_activity_types] = useState([]);
  const [activity_statuses, set_activity_statuses] = useState([]);
  const [activity_id, set_activity_id] = useState('');
  const [ac_activities, set_ac_activities] = useState([]);
  const [ac_tags, set_ac_tags] = useState([]);
  const [ac_scores, set_ac_scores] = useState([]);
  const [ac_lists, set_ac_lists] = useState([]);
  const [cw_activities, set_cw_activities] = useState([]);
  const [filter_options, set_filter_options] = useState({order:"orders[score]=", order_direction:"desc", sort_id:'', tag_id:'', list_id:'', page:1, resp:''});
  const [settings_open, set_settings_open] = useState(false);
  const [dates, set_dates] = useState({"first_day":moment().subtract(21, "days").format("YYYY-MM-DD"), "last_day":moment().format("YYYY-MM-DD")});
  const [temp_dates, set_temp_dates] = useState(dates);
  const [hide_options, set_hide_options] = useState(false);
  const [ac_items_loading, set_ac_items_loading] = useState(true);
  const [history, set_history] = useState(false);
  const [progress, set_progress] = useState([true]);
  const [tag_id, set_tag_id] = useState('');
  const [campaign_id, set_campaign_id] = useState('none');
  const [list_select_id, set_list_select_id] = useState();
  const [time_entry_start, set_time_entry_start] = useState(null);
  const [time_entry_end, set_time_entry_end] = useState(null);
  const [time_entry, set_time_entry] = useState(0);
  const [create_status_id, set_create_status_id] = useState(null);
  const [not_ready, set_not_ready] = useState(false);
  const [search_term, set_search_term] = useState('');
  const [request_loading, set_request_loading] = useState(false);
  var quick_dates = {"year":{"start":moment().startOf('year').format("YYYY-MM-DD"), "end":moment().endOf('year').format("YYYY-MM-DD")}, "quarter":{"start":moment().startOf('quarter').format("YYYY-MM-DD"), "end":moment().endOf('quarter').format("YYYY-MM-DD")}, "month":{"start":moment().startOf('month').format("YYYY-MM-DD"), "end":moment().endOf('month').format("YYYY-MM-DD")}, "week":{"start":moment().startOf('week').format("YYYY-MM-DD"), "end":moment().endOf('week').format("YYYY-MM-DD")}, "default":{"start":moment().subtract(21, "days").format("YYYY-MM-DD"), "end":moment().format("YYYY-MM-DD")}};
  useEffect(() => {
    getJobs();
  }, [])
  useEffect(() => {
    if(progress.length == 0){
      get_activity_types_html(v2_token, rec_id);
      get_cw_assignment_id(v2_token, rec_id, props.userContext);
      load_filtered_contacts(v2_token, rec_id);
      list_ac_items(v2_token, rec_id);
      get_activity_statuses(v2_token, rec_id);
    }
  }, [progress])
  useEffect(() => {
    if(filter_options.resp != ''){
      generate_table(v2_token, rec_id, filter_options.resp);
    }
  }, [filter_options])
  return(
    <div className="col-md-12" style={{marginTop : '20px'}}>
      <a href="/lead_safari/in_progress" style={{marginBottom : '10px'}} className="btn btn-primary">View In Progress</a>
     <div className="panel panel-default">
        <div className="panel-body">
          {!hide_options ? 
          <div style={{float: 'left'}}>
            <label style={{marginLeft : '15px'}}>DIRECTION</label>
            <select defaultValue={'desc'} onChange={(e) => filter(v2_token,rec_id,{"order_direction" : e.target.value})} className="form-control" style={{width : '125px', display: "inline", marginLeft: "5px"}}>
              <option value="asc">Ascending</option>
              <option value="desc">Decending</option>
            </select>
          </div>
          :''}
          {ac_items_loading ? 
            <div style={{textAlign: "center", position: 'absolute', right: 80}}>
             <i className="fa fa-cog fa-spin fa-1x"></i> Loading
            </div>
          :<div className="options" style={{float : 'right'}}>
          {!hide_options ?
             <span>
              <div className="fix-height" style={{width : '150px', display: "inline-block"}}>
                <label style={{marginLeft : '-35px', position : 'absolute', marginTop : '9px'}}>TAG</label>
                <Select value={tag_select.find(obj => obj.value === tag_id)} options={tag_select} onChange={(e:any) => (set_tag_id(e.value), filter(v2_token,rec_id,{"order":"orders[score]=", "tag_id" : e.value}))} />
              </div>
              <div className="fix-height" style={{width : '180px', display: "inline-block", marginLeft: "50px"}}>
                <label style={{marginLeft : '-35px', position : 'absolute', marginTop : '9px'}}>LIST</label>
                <Select value={list_select.find(obj => obj.value === list_select_id)} options={list_select} onChange={(e:any) => (set_list_select_id(e.value), filter(v2_token,rec_id,{"order":"orders[score]=", "list_id" : e.value}))}/>
              </div>
            </span>
          :
            <button onClick={(e) => (set_campaign_id("none"), set_hide_options(false), set_list_id(0), filter(v2_token,rec_id,{}),document.getElementById('campaign_select') as HTMLInputElement).value = "none"} className="btn btn-secondary">Clear Campaign Filter</button>
          }
          <div style={{width : '250px', display: "inline-block", marginLeft: "92px", marginRight: "5px"}}>
            <label style={{marginLeft : '-80px', position : 'absolute', marginTop : '9px'}}>CAMPAIGN</label>
            <Select className="fix-height" value={campaign_select.find(obj => obj.value === campaign_id)} options={campaign_select} onChange={(e:any) => {(e.value == 'none' ? (set_campaign_id(e.value), set_hide_options(false), set_list_id(0), filter(v2_token,rec_id,{})):(set_campaign_id(e.value), set_hide_options(true), switch_list(e.value,v2_token,rec_id, 1)))}}/>
          </div>
          <button onClick={(e) => set_settings_open(true)} className="btn btn-info"><i className="fa fa-cog"></i></button>
        </div>}
        </div>
      </div>
      <span>
        <div style={{borderRight : "3px solid #e5e5e5", float : "left", marginLeft : "50px", height : "40px"}}></div>
        <span className="form-inline col-md-4">
          <label style={{marginRight : "10px"}}>Search:</label>
          <input style={{height : "36px"}} onKeyPress={(e) => (e.key === 'Enter' ? search() : '')} onChange={(e) => (set_search_term(e.target.value))} type="text" value={search_term} className="input-sm form-control" id="search"/>
          <div style={{marginLeft: "5px", marginTop: "-10px"}} onClick={() => search()}  className="btn btn-primary btn-sm">Search</div>
        </span>
      </span>
      {progress.length ? 
        <div className="row" style={{paddingTop : "15px"}}>
          <div className="col-xs-3 col-md-offset-4">
            <div className="panel panel-default">
              <div className="panel-body">
                <div style={{textAlign: "center"}}>
                {progress}
                </div>
              </div>
            </div>
          </div>
        </div>
      :''}
      {loading ? 
      <div className="row" style={{paddingTop : "15px"}}>
        <div className="col-xs-3 col-md-offset-4">
          <div className="panel panel-default">
            <div className="panel-body">
              <div style={{textAlign: "center"}}>
              <i className="fa fa-cog fa-spin fa-2x"></i><br/>
              Loading
              </div>
            </div>
          </div>
        </div>
      </div>
    :pagination}
    
      <table id="contacts" className={loading ? 'table table-striped hidden' : 'table table-striped '} cellSpacing="0">
        <thead>
          <tr>
            <th className="th-sm col-md-2">Full Name
            </th>
            <th className="th-sm col-md-3">Contact
            </th>
            <th className="th-sm col-md-2">Company Name
            </th>
            <th className="th-sm col-md-3">Touches
            </th>
            <th className="th-sm col-md-3">Users
            </th>
            <th className="th-sm col-md-2">Options
            </th>
          </tr>
        </thead>
        <tbody>
          {contacts.length ? contacts : <tr><td style={{width: "25%", height: "100px"}}><span className="alert alert-info">No contacts opened this campaign</span></td></tr>}
        </tbody>
        <tfoot>
          <tr>
            <th className="th-sm">Full Name
            </th>
            <th className="th-sm">Contact
            </th>
            <th className="th-sm">Company Name
            </th>
            <th className="th-sm">Touches
            </th>
            <th className="th-sm">Users
            </th>
            <th className="th-sm">Options
            </th>
          </tr>
        </tfoot>
      </table>
      <Modal
        title="Settings"
        open={settings_open}
        submittable={false}
        closeText="Done"
        disallowClickOutside={false}
        close={() => {set_settings_open(false)}}>
          <h6 style={{marginLeft : '15px'}}>Select time period to get contact touch counts ( Default is past 21 days)</h6>
          <br/>
          <label style={{marginLeft : '15px'}}>Start date:</label>
          <input onChange={(e) => {temp_dates.first_day = e.target.value, set_temp_dates({...temp_dates})}} type="date" id="start" name="start" style={{display: "inline", marginLeft: "5px"}}
            value={temp_dates.first_day}/>
          <label style={{marginLeft : '15px'}}>End date:</label>
          <input onChange={(e) => {temp_dates.last_day = e.target.value, set_temp_dates({...temp_dates})}} type="date" id="start" name="end" style={{display: "inline", marginLeft: "5px"}}
            value={temp_dates.last_day}/>
          <button onClick={() => {set_dates(temp_dates), (list_id == 0 ? load_filtered_contacts(v2_token, rec_id) : switch_list(list_id,v2_token,rec_id, 1)), set_settings_open(false)}} className="btn btn-primary">Apply</button>
      </Modal>
      <Modal
        title="Activity"
        open={add_activity.open}
        isLarge={true}
        submittable={false}
        closeText="Cancel"
        disallowClickOutside={true}
        close={() => {set_notes(''), set_add_activity({open:false, type:'', email:'', contact_id:'', list_id:'', index_id:0, ac_contact_id: '', contact:{}})}}
      >
        {history ? '' :
          <span>
            <a className="btn btn-primary create-btn" role="button" onClick={(e) => ($('#collapse_id').collapse('show'), $('.close-btn').show(), set_time_entry(0))}>
              Create New Activity
            </a>
            <a style={{display : 'none'}} className="btn btn-danger close-btn pull-right" role="button" onClick={() => ($('#collapse_id').collapse('hide'),$('.close-btn').hide())}>
              X
            </a>
            <span className="collapse" id="collapse_id">
              <br/>
              <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="control-label">Activity Types</label>
                      <Select value={activity_types.find(obj => obj.value === activity_id)} options={activity_types} onChange={(e) => handle_select(e)} />
                    </div>
                  </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="control-label">Activity Status</label>
                    <Select value={activity_statuses.find(obj => obj.value === create_status_id)} options={activity_statuses} onChange={(e:any) => set_create_status_id(e.value)} />
                  </div>
                </div>
              </div>
              <div className="checkbox">
                  <label style={{fontWeight : "bold"}} data-toggle="collapse" data-target="#collapseTime">
                      <input style={{width: "auto",marginTop: "-11px"}} type="checkbox"/> Add Time Entry 
                  </label>
              </div>
              <span className={'collapse'} id="collapseTime">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="control-label">Start <small>(Time Entry)</small></label>
                      <input type="datetime-local" id="start" name="start" onChange={(e:any) => (set_time_entry_start(e.target.value))}/>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="control-label">End <small>(Time Entry)</small></label>
                      <input type="datetime-local" id="end" name="end" onChange={(e:any) => set_time_entry_end(e.target.value)}/>
                    </div>
                  </div>
                </div>
              </span>
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label>Summary:</label>
                    <input onChange={(e) => set_summary(e.target.value)} value={summary} type="text" className="form-control" id="summary"/>
                  </div>
                  <div className="form-group">
                    <label>Note:</label>
                    <input onChange={(e) => set_notes(e.target.value)} value={notes} type="text" className="form-control" id="note"/>
                  </div>
                  <button className="btn btn-primary" onClick={() => create_activity(v2_token, rec_id, assign_to, add_activity, notes, summary, activity_id, contacts, set_contacts, add_activity.index_id, add_activity.ac_contact_id, create_status_id, time_entry_start, time_entry_end).then(value => {set_add_activity({open:false, type:'', email:'', contact_id:'', list_id:'', index_id:0, ac_contact_id: '', contact:{}}), toast.success('Activity Created'), set_notes(''), set_create_status_id(''), set_time_entry_start(''), set_time_entry_end('')}, reason => {toast.error('Activity Not Created')})}>{request_loading? <i className="fa fa-cog fa-spin fa-1x"></i> : "Create Activity"}</button>
                </div>
              </div>
            </span>
            <hr/>
          </span>
        }
        <div>
        <ul className="nav nav-tabs" role="tablist">
          <li role="presentation" className="active"><a href="#connectwise" aria-controls="connectwise" role="tab" data-toggle="tab">ConnectWise</a></li>
          <li role="presentation"><a href="#ac" aria-controls="ac" role="tab" data-toggle="tab">Active Campaign</a></li>
        </ul>
        <br/>
        <div className="tab-content">
          <div role="tabpanel" className="tab-pane active" id="connectwise">{cw_activities}</div>
          <div role="tabpanel" className="tab-pane" id="ac">
            <h5>AC Lists</h5>
            <div>{ac_lists}</div>
            <hr/>
            <h5>AC Tags</h5>
            <div>{ac_tags}</div>
            <hr/>
            {ac_scores}<br/><br/>
            {ac_activities}
          </div>
        </div>
        </div>
      </Modal>
    </div>
  )
  
}

export default LeadSafari


// WEBPACK FOOTER //
// ./app/javascript/components/pages/LeadSafari.tsx